/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetUserContactsCount200ResponseAnyOf } from './getUserContactsCount200ResponseAnyOf';
import { GetUserContactsCount200ResponseAnyOf1 } from './getUserContactsCount200ResponseAnyOf1';


export interface GetUserContactsCount200Response { 
    count: number;
}

